import { createApp, h } from 'vue'
import ToastContainer from '../components/ui/notification/ToastContainer.vue'

class ToastService {
  private static container: HTMLDivElement | null = null
  private static toastComponent: any = null

  private static createContainer() {
    if (!this.container) {
      this.container = document.createElement('div')
      document.body.appendChild(this.container)
      
      const app = createApp({
        render() {
          return h(ToastContainer, {
            ref: (el: any) => {
              ToastService.toastComponent = el
            }
          })
        }
      })
      
      app.mount(this.container)
    }
    return this.container
  }

  // Set default type to 'info' here as well for consistency
  static show(
  message: string,
  type: 'info' | 'warning' | 'error' = 'info',
  timeout: number = 5000 // default 5s
) {
  this.createContainer()
  if (this.toastComponent) {
    this.toastComponent.addToast(message, type, timeout)
  }
}

}

export default ToastService